import { render, staticRenderFns } from "./FreshChatPopup.vue?vue&type=template&id=1f08e13d&scoped=true"
import script from "./FreshChatPopup.vue?vue&type=script&lang=js"
export * from "./FreshChatPopup.vue?vue&type=script&lang=js"
import style0 from "./FreshChatPopup.vue?vue&type=style&index=0&id=1f08e13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08e13d",
  null
  
)

export default component.exports